import vAccordion from "./v-accordion.vue";
import vAccordionGroup from "./v-accordion-group.vue";

export default Vue => {
  Vue.component("v-accordion-group", vAccordionGroup);
  Vue.component("v-accordion", vAccordion);
};
